import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { LanguageToggle } from "@/components/LanguageToggle";
import { BrandLockup } from "@/components/BrandLockup";

export const LegalLayout = ({ doc, testId }) => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#F6F5F2] flex flex-col" data-testid={testId}>
      <header className="border-b border-[#E2DFD8] bg-[#F6F5F2]/95 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" data-testid="brand-header">
            <BrandLockup />
          </Link>
          <LanguageToggle />
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto w-full px-6 md:px-12 py-14 md:py-16">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#4A5568] hover:text-[#0B0E14] transition-colors mb-10"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.75} />
          {t.footer.back}
        </Link>

        <h1 className="font-display text-3xl md:text-4xl font-light tracking-tight text-[#0B0E14]">{doc.title}</h1>

        <div className="mt-6 border-l-2 border-[#A68A56] bg-white px-4 py-3" data-testid="legal-review-note">
          <p className="text-xs text-[#8A6F3E] leading-relaxed">{t.legal.reviewNote}</p>
        </div>

        <div className="mt-10 flex flex-col gap-10">
          {doc.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-lg font-medium text-[#0B0E14] mb-3">{s.h}</h2>
              <div className="flex flex-col gap-2.5">
                {s.p.map((para, j) => (
                  <p key={j} className="text-sm text-[#4A5568] leading-relaxed">{para}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};
